import {TransactionWorkflowFilterTarget} from "./transaction-workflow-filter-target";
import {WorkflowFilterType} from "../_enums/workflow-filter-type";
import {TransactionWorkflowSub} from "./transaction-workflow-sub";

export class TransactionWorkflowFilter extends TransactionWorkflowSub {
  target: TransactionWorkflowFilterTarget = TransactionWorkflowFilterTarget.Composition;
  type: WorkflowFilterType = WorkflowFilterType.Contains;
}
